import { useParams } from 'react-router-dom';
import EmailHead from './Head';
import EmailContent from './Content';
import NotificationsFooter from '../Footer';
import { useENotificationsContext } from '../../../../context/e-notifications';

function NotificationEmail() {
  const { id } = useParams();
  const { emails } = useENotificationsContext();

  const email = emails?.find(el => el.key === id);

  if (!email) return null;

  return (
    <div>
      <div className="bg-white rounded w-full rounded-tr-lg rounded-tl-lg text-addition11">
        <EmailHead email={email} />
        <EmailContent email={email} />
      </div>
      <NotificationsFooter />
    </div>
  );
}

export default NotificationEmail;
